export default __webpack_public_path__ + "static/media/pin-card-registered.86635c9d.png";